import gsap from "gsap";
gsap.registerPlugin(ScrollTrigger);
const lenis = new Lenis({
    duration: 1.2,
    easing: (t) => Math.min((1, 1.001 - Math.pow(2, -10 * t)))
})
function raf(time) {
    lenis.raf(time);
    ScrollTrigger.update();
    requestAnimationFrame(raf)
}
requestAnimationFrame(raf)

const audio = document.getElementById('audio');
const soundbtn = document.querySelector("#soundbtn");
const soundoff = document.querySelector(".soundoff")
const soundon = document.querySelector(".soundon")
const startbtn = document.querySelector('.startbutton');
var loader = document.querySelector('.preloader');

startbtn.addEventListener("click", function () {
    loader.style.display = "none";
    audio.volume = 0.3;
    audio.play();
})

window.addEventListener('load', function () {
    const progressBar = document.querySelector('.circular-progress')
    const progressValue = progressBar.querySelector(".percentage");
    const innerCircle = progressBar.querySelector(".inner-circle");
    let startValue = 0,
        endValue = Number(progressBar.getAttribute("data-percentage")),
        speed = 50,
        progressColor = progressBar.getAttribute("data-progress-color");
    const progress = setInterval(() => {
        startValue++;
        progressValue.textContent = `${startValue}%`;
        progressValue.style.color = progressColor;
        progressBar.style.background = `conic-gradient(${progressColor} ${startValue * 3.6
            }deg, ${progressBar.getAttribute("data-bg-color")} 0deg)`;
        if (startValue === endValue) {
            innerCircle.style.width = "calc(var(--progress-bar-width) - -2px)"
            innerCircle.style.height = "calc(var(--progress-bar-height) - -2px)";
            progressValue.style.opacity = 0;
            startbtn.style.opacity = 1;
            startbtn.style.transform = "translateY(0px)";
            clearInterval(progress);
        }
    }, speed);
})
soundbtn.addEventListener("click", function () {
    if (audio.paused) {
        soundoff.style.transform = `translateY(0px)`;
        soundon.style.transform = `translateY(18px)`;
        audio.play();
    } else {
        soundoff.style.transform = `translateY(-18px)`;
        soundon.style.transform = `translateY(0px)`;
        audio.pause();
    }
})

const herotext = document.querySelector('.hero-text');
const cursorball = document.querySelector('.cursorball');
const circle = document.querySelector('.circle')
const socialIcons = document.querySelectorAll('.socialicon');
const menu = document.querySelector(".menu");
const sound = document.querySelector('.sound')
document.body.addEventListener('mousemove', onMouseMove);

herotext.addEventListener("mouseenter", enter)
herotext.addEventListener("mouseleave", exit)
menu.addEventListener("mouseenter", enter1)
menu.addEventListener("mouseleave", exit1)
sound.addEventListener("mouseenter", enter1)
sound.addEventListener("mouseleave", exit1)

function enter1(e) {
    circle.style.width = "0px";
    circle.style.height = "0px";
    adjustCursorPosition(e);
}
function exit1(e) {
    circle.style.width = "30px";
    circle.style.height = "30px";
    adjustCursorPosition(e);
}

function enter(e) {
    circle.style.width = "250px";
    circle.style.height = "250px";
    adjustCursorPosition(e);
}
function exit(e) {
    circle.style.width = "30px";
    circle.style.height = "30px";
    adjustCursorPosition(e);
}

function onMouseMove(e) {
    adjustCursorPosition(e);
    checkMagneticEffect(e);
}

function adjustCursorPosition(e) {
    const cursorSize = parseFloat(circle.style.width);
    const cursorOffset = cursorSize / 2;
    TweenMax.to(cursorball, .5, {
        x: e.clientX - cursorOffset,
        y: e.clientY - cursorOffset
    });
}

function checkMagneticEffect(e) {
    const magnetRadius = 15;
    socialIcons.forEach(icon => {
        const iconRect = icon.getBoundingClientRect();
        const iconCenterX = iconRect.left + iconRect.width / 2;
        const iconCenterY = iconRect.top + iconRect.height / 2;
        const distance = Math.sqrt(
            Math.pow(e.clientX - iconCenterX, 2) + Math.pow(e.clientY - iconCenterY, 2)
        );
        if (distance <= magnetRadius) {
            TweenMax.to(icon, 0.3, { x: e.clientX - iconCenterX, y: e.clientY - iconCenterY });
        } else {
            TweenMax.to(icon, 0.3, { x: 0, y: 0 });
        }
    });
}

gsap.to(".hero-text", {
    y: 100,
    scrollTrigger: {
        trigger: ".aboutus",
        scrub: 1,
        start: 'top 90%',
        end: 'bottom center',
    }
})

gsap.to(".bgvideo", {
    translateY: 100,
    scale: 1.3,
    scrollTrigger: {
        trigger: ".aboutus",
        scrub: 1,
        start: 'top 90%',
        end: 'bottom center',
    }
})

gsap.to(".abouttext p", {
    backgroundPositionX: "0%",
    stagger: 1,
    scrollTrigger: {
        trigger: ".abouttext",
        scrub: 1,
        start: "top 60%",
        end: "bottom 30%",
    },
});


const mytext = new SplitType('.whatidotext p');

gsap.to(".char", {
    y: 0,
    stagger: 0.05,
    scrollTrigger: {
        trigger: ".whatidotext",
        scrub: 1,
        start: "top 90%",
        end: "bottom 70%",
    }
})

gsap.to('.whatidobg', {
    rotation: 65,
    X: 100,
    y: 100,
    scrollTrigger: {
        trigger: '.whatido',
        scrub: 1,
        start: 'top 90%',
        end: 'bottom 70%',
    },
});

gsap.to('.mousediv', {
    rotation: 35,
    X: 0,
    y: -50,
    scrollTrigger: {
        trigger: '#mousep',
        scrub: 1,
        start: 'top 90%',
        end: 'bottom 70%',
    },
});

gsap.to(".experiencetext p", {
    backgroundPositionX: "0%",
    stagger: 1,
    scrollTrigger: {
        trigger: ".experiencetext",
        scrub: 1,
        start: "top 80%",
        end: "bottom 50%",
    },
});


gsap.to(".experiencecontainer", {
    y: 20,
    scrollTrigger: {
        trigger: ".history",
        scrub: 1,
        start: 'top 90%',
        end: 'bottom center',
    }
})


gsap.to(".c1", {
    opacity: 1,
    scrollTrigger: {
        trigger: ".whattheysaid",
        scrub: 1,
        start: 'top 100%',
        end: 'bottom 100%',
    }
})

gsap.to(".c2", {
    opacity: 1,
    scrollTrigger: {
        trigger: ".t2n",
        scrub: 1,
        start: 'top 90%',
        end: 'bottom 50%',
    }
})

gsap.fromTo(".triangle-laptop", {
    top: 50,
}, {
    top: 50,
    scrollTrigger: {
        trigger: ".whattheysaid",
        scrub: 1,
        start: 'top 90%',
        end: 'bottom 50%',
    }
})
gsap.fromTo(".triangle-mobile", {
    top: 0,
}, {
    top: 20,
    scrollTrigger: {
        trigger: ".whattheysaid",
        scrub: 1,
        start: 'top 90%',
        end: 'bottom 50%',
    }
})
gsap.fromTo(".triangle-mobile", {
    top: 20,
}, {
    top: 85,
    scrollTrigger: {
        trigger: ".t2n",
        scrub: 1,
        start: 'top 90%',
        end: 'bottom 50%',
    }
})
gsap.fromTo(".triangle-laptop", {
    top: 50,
}, {
    top: 150,
    scrollTrigger: {
        trigger: ".t2n",
        scrub: 1,
        start: 'top 90%',
        end: 'bottom 50%',
    }
})

gsap.to(".c3", {
    opacity: 1,
    scrollTrigger: {
        trigger: ".t3n",
        scrub: 1,
        start: 'top 100%',
        end: 'bottom 50%',
    }
})

gsap.fromTo(".triangle-laptop", {
    top: 150
}, {
    top: 300,
    scrollTrigger: {
        trigger: ".t3n",
        scrub: 1,
        start: 'top 100%',
        end: 'bottom 50%',
    }
})
gsap.fromTo(".triangle-mobile", {
    top: 80
}, {
    top: 150,
    scrollTrigger: {
        trigger: ".t3n",
        scrub: 1,
        start: 'top 100%',
        end: 'bottom 50%',
    }
})

gsap.to(".c1", {
    opacity: 0.1,
    scrollTrigger: {
        trigger: ".t2",
        scrub: 1,
        start: 'top 50%',
        end: 'bottom 100%',
    }
})
gsap.to(".c2", {
    opacity: 0.1,
    scrollTrigger: {
        trigger: ".t3",
        scrub: 1,
        start: 'top 50%',
        end: 'bottom 100%',
    }
})

gsap.to(".mottodiv", {
    width: "100%",
    scrollTrigger: {
        trigger: ".mottoh",
        scrub: 1,
        start: 'top 50%',
        end: 'bottom 10%',
    }
})

document.addEventListener('contextmenu', function (event) {
    event.preventDefault();
});